import React from 'react';
import './CustomPagination.scss';

// TenantSlide 파일 참고
const CustomPagination = () => <div className='swiper-pagination' />;

export default CustomPagination;
